<nav class="taskbar">
  <ul>
    <li class="taskbar-item">
      <a [routerLink]="['/coding', currentAgent, 'agent']">
        <i class="fas fa-video"></i>
        <ion-icon class="icon-taskbar" name="arrow-down-circle-sharp">
        </ion-icon>Agente
      </a>
    </li>
    <li class="taskbar-item">
      <a [routerLink]="['/coding', currentAgent, 'docs']">
        <i class="fas fa-file-alt"></i>
        <ion-icon class="icon-taskbar" name="document-text-outline">
        </ion-icon>Docs
      </a>
    </li>
    <li class="taskbar-item">
      <a [routerLink]="['/coding', currentAgent, 'links']">
        <i class="fas fa-link"></i>
        <ion-icon class="icon-taskbar" name="earth-outline">
        </ion-icon>Links
      </a>
    </li>
    <li class="taskbar-item">
      <a [routerLink]="['/coding', currentAgent, 'faqs']">
        <i class="fas fa-question-circle"></i>
        <ion-icon class="icon-taskbar" name="arrow-down-circle-sharp">
        </ion-icon>FAQs
      </a>
    </li>
  </ul>
</nav>